import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=7744cb9e&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=ts"
export * from "./Advantages.vue?vue&type=script&lang=ts"
import style0 from "./Advantages.vue?vue&type=style&index=0&id=7744cb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744cb9e",
  null
  
)

export default component.exports